// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","names":"TokensNames_names__O6C-j","platform":"TokensNames_platform__1XThT"};